import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    loadingIcon: {
      margin: 'auto',
      width: 60,
      height: 60,
      '& > path': {
        fill: 'var(--x-accent-1-1)',
        width: 39,
        height: 39,
      },
    },
  },
  {
    name: 'loader',
  },
);

export default useStyles;
